exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.contact[data-v-3e5205ea]{display:flex\n}\n.contact__wrapper[data-v-3e5205ea]{align-items:center;color:var(--color-neutral-gray-darker);display:flex;font-size:.875rem;line-height:1rem\n}\n.contact__whatsapp-icon[data-v-3e5205ea]{margin-right:8px\n}\n.contact__popover-text[data-v-3e5205ea]{color:var(--color-neutral-gray-dark);font-size:.9375rem;padding:8px 4px;text-align:center\n}\n.contact__link-color[data-v-3e5205ea]{color:var(--color-brand-primary-pure)\n}", ""]);

// exports
